export default __webpack_public_path__ + "static/media/diabetees.0921fef9.svg";